import { AsyncPipe } from '@angular/common'
import { Component, ViewEncapsulation } from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { usAnimations } from '@animations/index'
import { ProgressBarService } from './progress-bar.service'

@Component({
    selector: 'progress-bar-component',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    animations: [usAnimations],
    encapsulation: ViewEncapsulation.None,
    imports: [AsyncPipe, MatProgressBarModule]
})
export class ProgressBarComponent {
  constructor(public service: ProgressBarService) {}
}
